/* global APP */

// Suppress ResizeObserver benign errors
window.addEventListener('error', e => {
    if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        e.stopImmediatePropagation();
    }
});

import React from 'react';
import { createRoot } from 'react-dom/client';

import { getMeetHourTransport } from '../modules/transport';

import { App } from './features/app/components';
import { getLogger } from './features/base/logging/functions';
import { Platform } from './features/base/react';
import { getMeetHourGlobalNS } from './features/base/util';
import PrejoinApp from './features/prejoin/components/PrejoinApp';
import {
    sendWhiteBoardInstance,
    toogleEtherPad
} from './features/toolbox/actions.web';

const logger = getLogger('index.web');
const OS = Platform.OS;

/**
 * Renders the app when the DOM tree has been loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
    const now = window.performance.now();

    APP.connectionTimes['document.ready'] = now;
    logger.debug('(TIME) document ready:\t', now);
});

// Workaround for the issue when returning to a page with the back button and
// the page is loaded from the 'back-forward' cache on iOS which causes nothing
// to be rendered.
if (OS === 'ios') {
    window.addEventListener('pageshow', event => {
    // Detect pages loaded from the 'back-forward' cache
    // (https://webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/)
        if (event.persisted) {
            // Maybe there is a more graceful approach but in the moment of
            // writing nothing else resolves the issue. I tried to execute our
            // DOMContentLoaded handler but it seems that the 'onpageshow' event
            // is triggered only when 'window.location.reload()' code exists.
            window.location.reload();
        }
    });
}

/**
 * Stops collecting the logs and disposing the API when the user closes the
 * page.
 *
 * NOTE: `pagehide` is used instead of the deprecated `unload` event, which is
 * unreliable and is blocked by the Permissions Policy in modern browsers.
 */
window.addEventListener('pagehide', () => {
    // Stop the LogCollector
    if (APP.logCollectorStarted) {
        APP.logCollector.stop();
        APP.logCollectorStarted = false;
    }

    const { partId } = APP.store.getState()['features/genericiframe'];
    const participants = APP.store.getState()['features/base/participants'];
    const participantsD = participants.filter(i => i.local === true);
    const stateMent = APP.store.getState()['features/genericiframe'].visible;
    const { editing, partId: participantID }
    = APP.store.getState()['features/etherpad'];

    if (stateMent && participantsD[0]?.id === partId) {
        APP.store.dispatch(sendWhiteBoardInstance(false));
    }
    if (editing && participantID === participantsD[0]?.id) {
        APP.store.dispatch(toogleEtherPad(false));
    }

    const ele = document.getElementById('preloaderConference');

    const newEle = document.createElement('div');

    newEle.innerHTML = `<div style="
            position: relative;
            top: 58%;
            text-align: center;
        "><h4 style="color: #000;
                font-family: Poppins, sans-serif;
                font-size: 1.8rem
                font-weight: 500;
                line-height: 1.2;
            ">
        </h4></div>`;

    if (ele) {
        while (newEle.firstChild) {
            ele.appendChild(newEle.firstChild);
        }
        ele.style.opacity = '100%';
        ele.style.display = 'block';
    }
    APP.API.notifyConferenceLeft(APP.conference.roomName);
    APP.API.dispose();
    getMeetHourTransport().dispose();
});

const globalNS = getMeetHourGlobalNS();

globalNS.entryPoints = {
    APP: App,
    PREJOIN: PrejoinApp
};

globalNS.renderEntryPoint = ({
    Component,
    props = {},
    elementId = 'react'
}) => {
    const container = document.getElementById(elementId);
    const root = createRoot(container);

    root.render(<Component { ...props } />);
};
